import React from 'react';
import { Provider } from 'react-redux';
import PropTypes from 'prop-types';
import { PlayerModal } from '../components/player-modal/PlayerModal';

export const DraftTrackerPlayerModalProvider = ({ store, data }) => (
    <Provider store={store}>
        <PlayerModal {...data} />
    </Provider>
);

DraftTrackerPlayerModalProvider.propTypes = {
    store: PropTypes.object.isRequired,
    data: PropTypes.object
};
